import ManagementRouter from '../management/@config/router';
import ProductSetting from '../collection/@config/router';
import FlashSale from '../flashSale/@config/router';
import ModelSize from '../modelSize/@config/router';
import Extra from '../extra/@config/router';

export default {
    path: 'product',
    component: () => import('../Product.vue'),
    children: [
        ManagementRouter,
        ProductSetting,
        FlashSale,
        ModelSize,
        Extra,
    ]
};